import { Booking } from '@/entities/Booking'
import { Room } from '@/entities/Room'
import { BookingRequests } from '@/services/booking.requests'
const bookingService = new BookingRequests()

import Vue from 'vue'

const state = {
  read: null,
  edited: null,
  rooms: null
}

const getters = {}

const actions = {
  get ({ state }, { id }) {
    return new Promise((resolve, reject) => {
      bookingService.get(id).then(async (booking) => {
        state.read = booking
        resolve(booking)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  getRooms ({ state, dispatch }, { bookingId }) {
    return new Promise((resolve, reject) => {
      bookingService.getBookingRooms(bookingId).then(async (decoratedRooms) => {
        state.rooms = decoratedRooms
        await dispatch('getGuests', { decorate: true }).then((guests) => {
          const noRoomGuests = guests.filter((guest) => guest.roomId === null)
          state.rooms = state.rooms.map((decoratedRoom) => {
            decoratedRoom.guests = guests.filter((guest) => guest.roomId === decoratedRoom.room.id)
            return decoratedRoom
          })
          if (noRoomGuests.length) {
            state.rooms.push({
              room: new Room(),
              account: null,
              guests: noRoomGuests
            })
          }
          state.rooms.sort(function (a, b) {
            if (!a.room) {
              return -1
            }
            if (!b.room) {
              return 1
            }
            if (a.room.name > b.room.name) {
              return 1
            }
            if (a.room.name < b.room.name) {
              return -1
            }
            return 0
          })
          state.rooms.forEach(room => {
            room.guests.sort(function (a, b) {
              if (`${ a.profile.name }${ a.profile.lastName }${ a.id }` > `${ b.profile.name }${ b.profile.lastName }${ b.id }`) {
                return 1
              }
              if (`${ a.profile.name }${ a.profile.lastName }${ a.id }` < `${ b.profile.name }${ b.profile.lastName }${ b.id }`) {
                return -1
              }
              return 0
            })
          })
        })
        resolve(state.rooms)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  getGuests ({ state, dispatch }, { decorate }) {
    return new Promise((resolve, reject) => {
      bookingService.getBookingGuests(state.read.id).then(async (guests) => {
        state.guests = guests
        var promises = []
        if (decorate) {
          promises.push(dispatch('decorateProfile'))
          // FIXME: en su lugar, mostrar el ID de la cuenta o algo así para identificarla
          // promises.push(dispatch('decorateGuestAccount'))
        }
        Promise.all(promises).then(() => {
          resolve(guests)
        }).catch((error) => {
          reject(error)
        })
      }).catch((error) => {
        reject(error)
      })
    })
  },
  save ({ state, commit }, { id, profileId, accountId }) {
    return new Promise((resolve, reject) => {
      var read = state.read || new Booking()
      if (id) { commit('setField', { field: 'id', value: id }) }
      if (profileId) {
        commit('setField', { field: 'profileId', value: profileId })
      }
      if (accountId) {
        commit('setField', { field: 'accountId', value: accountId })
      }
      bookingService.save(read.serialize(state.edited)).then((id) => {
        resolve(id)
      }).catch((error) => {
        reject(error)
      })
    })
  },
  roomAccount ({}, { bookingId, roomId, accountId }) {
    return new Promise((resolve, reject) => {
      bookingService.roomAccount(bookingId, roomId, accountId).then(() => {
        resolve()
      }).catch((error) => {
        reject(error)
      })
    })
  },
  decorateProfile ({ state, dispatch }) {
    return new Promise((resolve, reject) => {
      var promises = []
      state.guests.forEach(guest => {
        promises.push(dispatch('profiles/get', { id: guest.profileId }, { root: true }).then((profile) => {
          guest.profile = profile
        }))
      })
      Promise.all(promises).then(() => {
        resolve(state.guests)
      }).catch((error) => {
        reject(error)
      })
    })
  }
}

const mutations = {
  setRead (state, profile) {
    state.read = profile
  },
  setField (state, { field, value }) {
    if (!state.edited) {
      state.edited = {}
      if (state.read && state.read.id) {
        Vue.set(state.edited, 'id', state.read.id)
      }
    }
    Vue.set(state.edited, field, value)
  },
  resetEdited (state) {
    state.edited = null
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}